import { apiFunction } from "../../../apiCalls/functions/"


export const handleChangePassword = async (data) => {
  return await apiFunction(`user/change-password`, 'post', data, true, false)
}